import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../servicios/api/api.service';

@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html',
  styleUrls: ['./calendario.component.css']
})
export class CalendarioComponent implements OnInit {

  constructor(
    private api:ApiService, 
    private router:Router
  ) { }

  ngOnInit(): void {
  }

  irCalendarioChv(){
    this.router.navigate(['calendariochv']);
  }

  irCalendarioFivi(){
    this.router.navigate(['calendariofivi']);
  }
}
